import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DocumentService } from '../../_services/document.services';

@Component({
  selector: 'app-bulk-update-status',
  templateUrl: './bulk-update-status.component.html',
  styleUrls: ['./bulk-update-status.component.scss']
})
export class BulkUpdateStatusComponent implements OnInit {

  bulkUpdateDetailsList : any[];
  noDocuments: boolean = false;
  docLength: number;
  docsList: MatTableDataSource<any>;
  documentCols: String[] = ["created_by", "create_date", "search_query","update_values","document_count","completed_date","operation_status"];
  selectedRow: Array<JSON> = [];

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) { 
    this.sort = content;
    if (this.sort && this.docsList) {
      this.docsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator && this.docsList) {
      this.docsList.paginator = this.paginator;
    }
  }
  
  constructor(
    private documentService: DocumentService
  ) { }

  ngOnInit() {
    this.getBulkUpdateDetails();
  }

//   downloadLink(fileName) {
//     this.documentService.getDownloadLink(fileName).subscribe(link => {
//       var url = link.slice(5)
//       window.open(url,'_blank');
//     });
//   }

  getBulkUpdateDetails() {
    this.documentService.getBulkUpdateStatus()
      .subscribe(docs => {
        this.bulkUpdateDetailsList = []
        if (docs == undefined || docs == "No Export File to display") {
          this.noDocuments = true;
        }
       
        this.bulkUpdateDetailsList = docs
        this.docLength = this.bulkUpdateDetailsList.length;
        this.docsList = new MatTableDataSource(this.bulkUpdateDetailsList);
        this.docsList.sort = this.sort;
        this.docsList.paginator = this.paginator;
      }, error => {
        console.log(error);
        this.noDocuments = true;
      });
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.docsList.filter = filterValue.trim().toLowerCase();
    if (this.docsList.paginator) {
      this.docsList.paginator.firstPage();
      this.docLength = this.docsList.filteredData.length
    }
  }

  refresh() {
    this.getBulkUpdateDetails();
  }

}
